const timelineColors = {
  PLANNED_MAINTENANCE: {
    timelineElement: 'var(--bg-link)',
    timelineElementHover: 'var(--bg-timeline-element-hover-planned)',
    timelineElementContent: 'var(--link-border)',
    timelineElementPoint: 'var(--text-link)',
  },
  OVERDUE_MAINTENANCE: {
    timelineElement: 'var(--error-bg)',
    timelineElementHover: 'var(--bg-timeline-element-hover-overdue)',
    timelineElementContent: 'var(--error-border)',
    timelineElementPoint: 'var(--text-error)',
  },
  COMPLETED_MAINTENANCE: {
    timelineElement: 'var(--succes-bg)',
    timelineElementHover: 'var(--bg-timeline-element-hover-completed)',
    timelineElementContent: 'var(--success-border)',
    timelineElementPoint: 'var(--success)',
  },
  NO_RESPONSIBLE: {
    timelineElement: 'var(--warning-bg)',
    timelineElementHover: 'var(--bg-timeline-element-hover-no-respinsible)',
    timelineElementContent: 'var(--warning-border)',
    timelineElementPoint: 'var(--text-warning)',
  },
}

const maintenanceGracePeriod = 3
const timelineConstants = { timelineColors, maintenanceGracePeriod }
export default timelineConstants
